<template>
<v-container fluid class="multiaccess-page fill-height">
    <v-row align="center" justify="center" class="fill-height">
      <v-col cols="12" sm="10" md="9" lg="8">
        <v-card class="auth-card rounded-xl overflow-hidden" elevation="8">
          <v-row no-gutters>
            <v-col cols="12" md="5" class="quick-links-panel pa-8 d-flex flex-column justify-center">
              <v-icon size="44" class="mb-3 white--text">mdi-account-multiple-outline</v-icon>
              <div class="text-overline font-weight-bold white--text">RESULTS ACCESS</div>
              <div class="text-h5 font-weight-bold white--text mb-2">Parents, Teachers &amp; Students</div>
              <div class="text-body-2 white--text multiaccess-blurb">
                Login with your <strong>PIN &amp; KEY &amp; LAST NAME</strong> to gain access. You should never disclose your PIN/KEY to anyone.
              </div>
            </v-col>

            <v-col cols="12" md="7">
              <v-card-text class="pa-8 pa-md-10">
                <div class="text-overline font-weight-bold accent--text">QUICK ACCESS</div>
                <div class="text-h5 font-weight-bold mb-1">Enter your access details</div>
                <div class="text-body-2 grey--text mb-6">Use the PIN and KEY provided by your school, along with your last name.</div>

                <v-form ref="form">
                    <v-row>
                        <v-col
                        cols="12"
                        md="6"
                        >
                            <v-text-field
                                v-model="form.key"
                                label="KEY"
                                :rules="[v => !!v || 'Enter your KEY']"
                                prepend-inner-icon="mdi-key-outline"
                                outlined
                                required
                            ></v-text-field>
                        </v-col>
                        <v-col
                        cols="12"
                        md="6"
                        >
                            <v-text-field
                                v-model="form.pin"
                                label="PIN"
                                :rules="[v => !!v || 'Enter your PIN']"
                                prepend-inner-icon="mdi-numeric"
                                outlined
                                required
                            ></v-text-field>
                        </v-col>
                        <v-col
                        cols="12"
                        md="6"
                        >
                            <v-text-field
                                v-model="form.fullname"
                                label="LAST NAME"
                                :rules="[v => !!v || 'Enter your last name']"
                                prepend-inner-icon="mdi-account-outline"
                                outlined
                                required
                            ></v-text-field>
                        </v-col>
                        <v-col
                        cols="12"
                        md="6"
                        class="d-flex align-center"
                        >
                            <v-btn
                            color="primary"
                            large
                            rounded
                            elevation="2"
                            class="font-weight-bold text-none"
                            @click="postRecord"
                            >
                                Go
                                <v-icon right>mdi-arrow-right</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';
  export default {
    name: 'MultiAccessLogin',
    components: {
    },
    mounted() {//
    },
    data: () => ({
        form: {},
    }),
    metaInfo: {
        meta: [
            { name: 'viewport', content: 'width=device-width,initial-scale=1.0' }
        ]
    },
    methods: {
        postRecord () {
            let validation = this.$refs.form.validate()
            if(!validation) {
                return validation
            }
            let loader = this.$loading.show()
            axios.post(process.env.VUE_APP_BASEURL+'/multiaccess/signin',this.form,
            {})
            .then((response) => {
                sessionStorage.accessToken =  response.data.data.access_token
                sessionStorage.utpc =  response.data.data.user_type
                localStorage.school =  JSON.stringify(response.data.data.school)
                this.$store.commit("isTokenAccess", true);
                this.$store.commit("isLoggedIn", false);
                sessionStorage.removeItem('authToken')
                if (response.data.data.user_type == 'Teacher') {
                    this.$router.push({name: 'StudentScores'})
                }
                else{
                    this.$router.push({name: 'ResultSheets'})
                }
            })
            .catch((error) => {
                this.$toast.error(error.response ? error.response.data.message : 'Network Error, Please try again few minutes', {
                    timeout: 5000
                });
            })
            .finally(() => {
                loader.hide()
            });
        },
    },
  }
</script>

<style scoped>
.multiaccess-page {
    min-height: calc(100vh - 64px);
}
.quick-links-panel {
    background: linear-gradient(180deg, #1E3C72 0%, #142A52 100%);
    min-height: 100%;
}
.multiaccess-blurb {
    opacity: 0.85;
    max-width: 340px;
}
</style>
